import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { UtilService } from "services/shared/UtilService";
import ApiUrl from "services/shared/ApiUrl";
import { msgTypes } from "constants/msgTypes";
import { BlogModel } from "../blog/BlogModal";
import { Link } from "react-router-dom"; 
import DOMPurify from 'dompurify';
// Import Link for navigation
const BlogDetails = () => {
    const { blogId } = useParams(); // Get the blogId from URL
    const [blogDetails, setBlogDetails] = useState(new BlogModel());
    const [latestBlogs, setLatestBlogs] = useState([]);


    useEffect(() => {
        getBlogDetails();
        getLatestBlogs();
    }, [blogId]); // Fetch blog details whenever the blogId changes

    const getBlogDetails = async () => {
        // Fetch the blog details using the blogId
        const res = await UtilService.getBlogDetailtList({ blogId });
        if (res.statusMsg === msgTypes.SUCCESS.msg) {
            setBlogDetails(res?.data || {});
        }
    };


    const getLatestBlogs = async () => {
        const res = await UtilService.getLatestBlog(); // replace with actual API call
        if (res.statusMsg === msgTypes.SUCCESS.msg) {
            setLatestBlogs(res?.data);
        } else {
            setLatestBlogs([]); // fallback to safe default
        }
    };



    return (
        <>
            {/* Page Header Start */}
            <section className="page-header">
                <div className="page-header__bg blog-details-banner">
                    {/* You can add a dynamic image here if you get the image URL from API */}
                    <img src={blogDetails.image ? ApiUrl.fileBaseUrl + blogDetails.image : "/images/default-image.png"} alt={blogDetails.altTag || "Blog image"} />
                </div>
            </section>
            {/* Page Header End */}

            {/* Blog Details Start */}
            <section className="blog-details">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-8 col-lg-7">
                            <div className="blog-details__left">
                                <div className="blog-details__img">
                                    {/* Display blog image */}
                                    {/* <img src={blogDetails.image ? ApiUrl.fileBaseUrl + blogDetails.image : "/images/default-image.png"} alt={blogDetails.altTag || "Blog image"} /> */}
                                </div>
                                <div className="blog-details__content">
                                    {/* <ul className="blog-details__meta list-unstyled">
                                        <li>
                                            <a href="#">
                                                <span className="icon-comments-2"></span>Comments (05)
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <span className="icon-user-2"></span>By {blogDetails.author || "Admin"}
                                            </a>
                                        </li>
                                    </ul> */}
                                    <h3 className="blog-details__title-1">{blogDetails.title}</h3>
                                    <p className="blog-details__text-1"dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(blogDetails.description || "") }}

 
></p>
                                    <p className="blog-details__text-2">{blogDetails.content}</p>
                                </div>
                            </div>
                        </div>

                        {/* Sidebar Start */}
                        <div className="col-xl-4 col-lg-5">
                            <div className="sidebar">
                                <div className="sidebar__single sidebar__post">
                                    <h3 className="sidebar__title">Latest Blogs</h3>
                                    <ul className="sidebar__post-list list-unstyled">
                                        {latestBlogs.map((blog) => (
                                            <li key={blog.blogId}>
                                                <div className="sidebar__post-image">
                                                    <img
                                                        src={blog.image ? ApiUrl.fileBaseUrl + blog.image : "/images/default-image.png"}
                                                        alt={blog.altTag || "Blog image"}
                                                    />
                                                </div>
                                                <div className="sidebar__post-content">
                                                    <Link to={`/blog-details/${blog.blogId}`}>
                                                        <h4>{blog.title}</h4>
                                                    </Link>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>



                                </div>

                                {/* <div className="sidebar__single sidebar__tags">
                                    <h3 className="sidebar__title">Tags</h3>
                                    <div className="sidebar__tags-list">
                                        <a href="#">Events</a>
                                        <a href="#">Conferences</a>
                                        <a href="#">News & Media</a>
                                        <a href="#">Verticals</a>
                                        <a href="#">CSR</a>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                        {/* Sidebar End */}
                    </div>
                </div>
            </section>
            {/* Blog Details End */}
        </>
    );
};

export default BlogDetails;
